// extracted by mini-css-extract-plugin
export var addButton = "_n6-0";
export var border = "_n6-8";
export var check = "_n6-h";
export var danger = "_n6-6";
export var dropdownContainer = "_n6-1";
export var editModalBody = "_n6-j";
export var footerContainer = "_n6-i";
export var fullWidth = "_n6-a";
export var hide = "_n6-9";
export var icon = "_n6-3";
export var input = "_n6-7";
export var inputFlex = "_n6-b";
export var inputWrapper = "_n6-c";
export var manualFocus = "_n6-5";
export var optionButton = "_n6-4";
export var pillWrapper = "_n6-e";
export var pointer = "_n6-2";
export var showOverflow = "_n6-f";
export var tagsFlex = "_n6-d";
export var xButton = "_n6-g";